import styled, { css } from 'styled-components';
import Slider from 'react-slick';
import LinkComponent from '@components/link';
import { generateScales } from '@helpers/generate-media-queries';
import Image from '@components/image';
import Text from '@components/text';
import Section from '@components/section';

export const StyledSection = styled(Section)``;

export const FeatureWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    gap: 4rem;
    align-items: center;
    justify-content: space-between;
    flex-direction: row-reverse;

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      gap: 3rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      flex-direction: column;
      align-items: flex-start;
      gap: 2.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      gap: 2rem;
      flex-direction: column-reverse;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      gap: 1.5rem;
    }
  `}
`;

export const TextContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
    max-width: 34rem;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      max-width: 100%;
    }
  `}
`;

export const TitleContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    text-align: left;

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      gap: 0.75rem;
    }
  `}
`;

export const StyledText = styled(Text)`
  ${({ theme }) => css`
    ul {
      font-size: 1rem;
      line-height: 1.4;
      list-style-position: inside;

      @media only screen and (max-width: ${theme.breakpoints.md}) {
        margin-left: 0.75rem;
      }

      li + li {
        margin-top: 0.75rem;
      }
    }
  `}
`;

export const StyledLinkComponent = styled(LinkComponent)`
  ${({ theme }) => css`
    width: fit-content;
    margin: 0.5rem 0 0 0;
    border: 2px solid ${theme.colors.primary};
    background-color: transparent;
    color: ${theme.colors.secondary};
    ${generateScales('font-size', theme.fontSize.body.mobile, theme.fontSize.body.desktop, theme)}
    transition: transform ${theme.transitions.short}, background-color ${theme.transitions.short},
      border-color ${theme.transitions.short};

    &:hover {
      transform: scale(1.05);
      background-color: ${theme.colors.primary};
      border-color: ${theme.colors.primary};
      color: ${theme.colors.secondary};
    }

    &:active {
      transform: scale(0.97);
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      margin-top: 0.25rem;
    }
  `}
`;

export const CarouselColumn = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 38rem;
    min-width: 0;
    margin-bottom: 2rem;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      max-width: 100%;
    }
  `}
`;

export const StyledSlider = styled(Slider)`
  ${({ theme }) => css`
    width: 100%;

    .slick-track {
      display: flex;
      gap: 1.5rem;
    }

    .slick-slide {
      display: flex;
      justify-content: center;
      height: auto;
    }

    .slick-slide > div {
      width: 100%;
    }

    .slick-dots {
      display: flex !important;
      justify-content: center;
      gap: 0.75rem;
      margin-top: 1.25rem;
    }

    .slick-dots li {
      margin: 0;
      width: auto;
      height: auto;
    }

    .slick-dots li button {
      padding: 0;
      width: 0.75rem;
      height: 0.75rem;
      border-radius: 50%;
      background-color: ${theme.colors.light};
      border: 0;
      text-indent: -9999px;
      transition: transform ${theme.transitions.short}, background-color ${theme.transitions.short};
    }

    .slick-dots li button:before {
      display: none;
    }

    .slick-dots li.slick-active button {
      background-color: ${theme.colors.primary};
      transform: scale(1.15);
    }
  `}
`;

export const Slide = styled.div`
  ${({ theme }) => css`
    width: 100%;
    border-radius: ${theme.borderRadius.large};
    background-color: ${theme.backgroundColors.light};
    display: flex;
  `}
`;

export const CarouselImage = styled(Image)`
  width: 100%;
  height: auto;
`;
